import React from 'react';
import { 
  AppBar, 
  Toolbar, 
  Button, 
  Box, 
  IconButton,
  useMediaQuery,
  Menu,
  MenuItem,
  Typography
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { styled } from '@mui/system';

const HeaderLogo = styled('img')(({ theme }) => ({
  height: 60,
  marginRight: theme.spacing(3),
  [theme.breakpoints.down('sm')]: {
    height: 40,
  },
}));

const HeaderButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing(0, 1),
  borderRadius: 20,
  fontWeight: 600,
  padding: theme.spacing(0.75, 2),
  textTransform: 'none',
  transition: 'all 0.3s ease',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: '0 4px 8px rgba(55, 91, 210, 0.2)',
  },
}));

const Header = ({ isDarkMode, toggleTheme }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleButtonClick = (url) => {
    window.open(url, '_blank');
    handleMenuClose();
  };

  return (
    <AppBar position="fixed" color="primary" elevation={2}>
      <Toolbar sx={{ justifyContent: 'space-between' }}>
        <Box component="a" href="https://hero.evidencer.io/" target="_blank" rel="noopener noreferrer">
          <HeaderLogo 
            src="https://freeweb3.infura-ipfs.io/ipfs/QmPE3vX6FkhxUTWSTHr8XqaxaM1r5C7MTb3bQB59zr196M" 
            alt="Evidencer Logo" 
          />
        </Box>

        {isMobile ? (
          <>
            <Box display="flex" alignItems="center">
              <IconButton 
                color="inherit" 
                onClick={toggleTheme} 
                sx={{ mr: 1 }}
                aria-label={isDarkMode ? "Switch to light mode" : "Switch to dark mode"}
              >
                {isDarkMode ? "☀️" : "🌙"}
              </IconButton>
              
              <IconButton 
                color="inherit" 
                onClick={handleMenuClick}
                edge="end"
                aria-label="Menu"
              >
                <Typography variant="h5">☰</Typography>
              </IconButton>
              
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
              >
                <MenuItem onClick={() => handleButtonClick('https://keypairs.freeweb3.com')}>
                  digital_id
                </MenuItem>
                <MenuItem onClick={() => handleButtonClick('https://upload-encrypted.freeweb3.com/')}>
                  file_store
                </MenuItem>
                <MenuItem onClick={() => handleButtonClick('https://cidtochain.evidencer.io/')}>
                  time_stamp
                </MenuItem>
              </Menu>
            </Box>
          </>
        ) : (
          <Box display="flex" alignItems="center">
            <HeaderButton 
              variant="contained" 
              color="secondary" 
              onClick={() => window.open('https://keypairs.freeweb3.com', '_blank')}
            >
              digital_id
            </HeaderButton>
            
            <HeaderButton 
              variant="contained" 
              color="secondary" 
              onClick={() => window.open('https://upload-encrypted.freeweb3.com/', '_blank')}
            >
              file_store
            </HeaderButton>
            
            <HeaderButton 
              variant="contained" 
              color="secondary" 
              onClick={() => window.open('https://cidtochain.evidencer.io/', '_blank')}
            >
              time_stamp
            </HeaderButton>
            
            <IconButton 
              color="inherit" 
              onClick={toggleTheme} 
              sx={{ ml: 2 }}
              aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
            >
              {isDarkMode ? "☀️" : "🌙"}
            </IconButton>
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Header;